import { render, staticRenderFns } from "./UiAccordionItem.vue?vue&type=template&id=3a4718bf&"
import script from "./UiAccordionItem.vue?vue&type=script&lang=js&"
export * from "./UiAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports